import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

const PdpRespPriceNegotiationToast = React.lazy(() =>
    import(/* webpackChunkName: "PdpRespPriceNegotiationToastChunk" */ './PdpRespPriceNegotiationToast')
);

export function PdpRespPriceNegotiationToastLoaderComponent(props) {
    return (
        <React.Suspense fallback={null}>
            <PdpRespPriceNegotiationToast
                currency={props.currency}
                displayInfo={props.displayInfo}
                item={props.item}
                userId={props.userId}
            />
        </React.Suspense>
    );
}

PdpRespPriceNegotiationToastLoaderComponent.propTypes = {
    currency: PropTypes.string,
    displayInfo: PropTypes.object,
    item: PropTypes.object,
    userId: PropTypes.string,
};

export const PdpRespPriceNegotiationToastLoader = createFragmentContainer(
    PdpRespPriceNegotiationToastLoaderComponent,
    {
        displayInfo: graphql`
            fragment PdpRespPriceNegotiationToastLoader_displayInfo on ItemDisplayInfo {
                ...PdpRespPriceNegotiationToast_displayInfo
            }
        `,
        item: graphql`
            fragment PdpRespPriceNegotiationToastLoader_item on Item {
                ...PdpRespPriceNegotiationToast_item
            }
        `,
    }
);
